import { render, staticRenderFns } from "./SessionBox.vue?vue&type=template&id=5619a06c"
import script from "./SessionBox.vue?vue&type=script&lang=js"
export * from "./SessionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports